import { PATHS, VOICE_NAME_MAPPING } from '../constants';

export const loadStoryData = async (bookdata, defaultData) => {
  try {
    if (!bookdata) {
      console.log('No bookdata provided, using default');
      return defaultData;
    }

    // Always use defaultData if available
    if (defaultData) {
      console.log('Using provided default data');
      return defaultData;
    }

    // If it's a CDN URL, fetch it
    if (bookdata.startsWith('https://')) {
      try {
        const response = await fetch(bookdata, {
          method: 'GET',
          mode: 'cors',
          headers: {
            'Accept': 'application/json'
          }
        });
        
        if (!response.ok) {
          const noCorsFetch = await fetch(bookdata, {
            method: 'GET',
            mode: 'no-cors',
            headers: {
              'Accept': 'application/json'
            }
          });
          
          if (!noCorsFetch.ok) {
            throw new Error(`HTTP error! status: ${noCorsFetch.status}`);
          }
          
          const text = await noCorsFetch.text();
          return JSON.parse(text);
        }
        
        return await response.json();
      } catch (error) {
        console.error('Error fetching from CDN:', error);
        return defaultData;
      }
    }

    return defaultData;
  } catch (error) {
    console.error('Error loading story data:', error);
    return defaultData;
  }
};

export const getAudioPath = (bookId, chapterName, sceneId, voicePreference) => {
  const bookConfig = PATHS.AUDIO.BOOKS[bookId];
  
  if (!bookConfig || !bookConfig.hasAudio) {
    console.log(`No audio support for book: ${bookId}`);
    return null;
  }

  const chapter = chapterName.toLowerCase().replace(' ', '_');
  
  const usesNewNaming = bookConfig.usesNewNaming === true;
  
  let effectiveVoice = voicePreference;
  
  if (usesNewNaming) {
    if (voicePreference === 'male') {
      effectiveVoice = 'Johan';
    } else if (voicePreference === 'female') {
      effectiveVoice = 'Lisbeth';
    }
  } else {
    if (voicePreference === 'Johan') {
      effectiveVoice = 'male';
    } else if (voicePreference === 'Lisbeth') {
      effectiveVoice = 'female';
    }
  }
  
  const voiceSuffix = bookConfig.pathFormat[effectiveVoice] || '';
  
  const audioPath = `${PATHS.AUDIO.BASE}/${bookConfig.path}/${chapter}/scene_${sceneId}${voiceSuffix}.mp3`;
  console.log(`Audio path for ${bookId}, ${chapter}, scene ${sceneId}, voice ${voicePreference} (effective: ${effectiveVoice}): ${audioPath}`);
  
  return audioPath;
};

export const hasAudioSupport = (bookId) => {
  const bookConfig = PATHS.AUDIO.BOOKS[bookId];
  return bookConfig?.hasAudio || false;
};

export const saveStoryState = (storyId, chapter, sceneId) => {
  try {
    const storyState = { chapter, sceneId };
    const id = storyId || 'default';
    localStorage.setItem(`storyState_${id}`, JSON.stringify(storyState));
    return storyState;
  } catch (error) {
    console.error('Error saving story state:', error);
    return null;
  }
};

export const loadSavedState = (storyId) => {
  try {
    const id = storyId || 'default';
    const savedState = localStorage.getItem(`storyState_${id}`);
    if (!savedState) return null;
    
    const parsedState = JSON.parse(savedState);
    if (!parsedState.chapter || !parsedState.sceneId) {
      throw new Error('Invalid saved state format');
    }
    
    return parsedState;
  } catch (error) {
    console.error('Error loading saved state:', error);
    localStorage.removeItem(`storyState_${storyId}`); // Clear invalid state
    return null;
  }
};

export const saveLastBook = (bookData) => {
  try {
    localStorage.setItem('lastBook', JSON.stringify(bookData));
  } catch (error) {
    console.error('Error saving last book:', error);
  }
};

export const getLastBook = () => {
  try {
    const lastBook = localStorage.getItem('lastBook');
    return lastBook ? JSON.parse(lastBook) : null;
  } catch (error) {
    console.error('Error loading last book:', error);
    return null;
  }
}; 